const metadataContent = {
  description: {
    default: 'Home Depot Stores',
    searchLoader: (
      'Use store finder to find a nearby Home Depot store location. '
      + 'Find a store location and save time and money with store finder from The Home Depot.'
    ),
    storeDirectory: 'The Home Depot is here to help with your home improvement needs.'
      + ' Stop by at one of our locations today.',
  },
  title: {
    default: 'Home Depot Stores',
    searchLoader: 'Find Any Nearby Home Depot Store | Store Finder | The Home Depot',
    storeDirectory: 'Store Directory - The Home Depot',
  },
};

export const getPageInformation = (url = '') => {
  const canonicalURL = url?.split('?')[0];
  const isSearchLoaderPage = canonicalURL === '/l/' || canonicalURL === '/l';
  const isStoreDirectoryPage = canonicalURL.toLowerCase().includes('storedirectory');
  let pageInformation = {};

  switch (true) {
  case (isSearchLoaderPage):
    pageInformation = { page: 'searchLoader', canonicalURL };
    break;
  case (isStoreDirectoryPage):
    pageInformation = { page: 'storeDirectory', canonicalURL: '/l/storeDirectory' };
    break;
  default:
    pageInformation = { page: 'default', canonicalURL };
  }

  return pageInformation;
};

const cacheKey = ({ url: requestURL, hashCode }) => {
  try {
    const { pathname } = new URL(requestURL);
    return `${pathname}:${hashCode}`;
  } catch (error) {
    return `${requestURL}:${hashCode}`;
  }
};

export const formatStoreLinks = (stores) => {
  const countryCodes = ['GU', 'PR', 'US', 'VI'];

  const sortStoresByName = (previousStore, currentStore) => {
    if (previousStore.storeName < currentStore.storeName) {
      return -1;
    }
    if (previousStore.storeName > currentStore.storeName) {
      return 1;
    }
    return 0;
  };

  return stores
    .filter((store) => countryCodes.includes(store.address.country))
    .reduce((arrayOfStores, storeObject) => {
      const { address: { city, postalCode, state }, storeId, storeName } = storeObject;
      const storeLink = `${storeName}/${state}/${city}/${postalCode}/${storeId}`
        .trim() // Remove spaces at the beginning and ending of the string
        .replace(/\s\/+/g, '/') // Replace spaces before a / with a /
        .replace(/\s+/g, '-'); // Replace all spaces with -

      return [...arrayOfStores, { storeLink, storeName }];
    }, [])
    .sort(sortStoresByName);
};

export const getStoreLinks = async (system) => {
  let url = `${system?.data?.hosts?.api}/StoreSearchServices/v2/StoreInfo?key=8Qg7Ztll8bnnEtlORRt7ReviHGrrnvo4`;

  const getStores = await system.fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, cacheKey);

  if (getStores?.stores?.length > 0) {
    return formatStoreLinks(getStores.stores);
  }

  return [];
};

export const getCachedStoreLinks = () => {
  const cachedStores = window.__FETCH_CACHE['/StoreSearchServices/v2/StoreInfo:code']?.stores;
  if (cachedStores && cachedStores.length > 0) {
    return formatStoreLinks(cachedStores);
  }

  return [];
};

export const getDescription = (page) => {
  const { description } = metadataContent;

  return description[page];
};

export const getTitle = (page) => {
  const { title } = metadataContent;

  return title[page];
};

export const getMetadataInformation = (url) => {
  const { canonicalURL, page } = getPageInformation(url);
  const title = getTitle(page);
  const description = getDescription(page);

  return { canonicalURL, description, title };
};